module.exports = __webpack_public_path__ + "img/domicile3.2bffd29d.jpg";